export default {
  "region": {
    "title": "Our Region",
    "description1": "The caldera of an extinct volcano from 80 million years ago helped define an area of volcanic soil between southern Minas Gerais and northeastern São Paulo, which, due to its climate and terrain characteristics, delineates a unique \"terroir\" where our coffees are produced.",
    "description2": "Our demarcated and protected territory covers 12 municipalities located in the mountains that separate these two important Brazilian coffee-producing states.",
    "map_alt": "Map of the Volcanic Region"
  }
}
